/* Lorelia · Produktseiten-Abschnitte (Paket D, 05.10.2026). Kein Framework, läuft einmal pro Seite.
   1) Abschnitte blenden EINMAL beim Erscheinen ein (nichts am Scroll gekoppelt); reduzierte Bewegung = sofort sichtbar.
   2) „Jetzt gestalten“ (Schmuck) springt zum Eingabefeld oben und setzt den Fokus.
   3) Handy: Klebeleiste „Jetzt gestalten“ nur, solange das Feld leer ist und der Kaufbereich weggescrollt ist –
      dann wird die Kaufleiste von lr-sch-produkt so lange ausgeblendet (nie zwei Leisten übereinander). */
(function () {
  'use strict';
  if (window.__lrpd) return; window.__lrpd = 1;
  var D = document, H = D.documentElement;
  var RUHIG = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  H.classList.add('lrpd-js');

  function los() {
    /* ---------- 1) Einblenden ---------- */
    var ziele = [].slice.call(D.querySelectorAll('.lrpd [data-lrpd-auf]'));
    if (RUHIG || !('IntersectionObserver' in window)) {
      ziele.forEach(function (e) { e.classList.add('is-da'); });
    } else {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-da'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      ziele.forEach(function (e) {
        var r = e.getBoundingClientRect();
        if (r.top < innerHeight * 0.92 && r.bottom > 0) e.classList.add('is-da'); else io.observe(e);
      });
      /* Sicherheit: nach 4 s ist alles sichtbar, auch wenn ein Beobachter nicht feuert */
      setTimeout(function () { ziele.forEach(function (e) { if (e.getBoundingClientRect().top < innerHeight) e.classList.add('is-da'); }); }, 4000);
    }

    /* ---------- 2) Jetzt gestalten (Schmuck) ---------- */
    var feld = D.getElementById('sch-name') || D.getElementById('sch-gravur');
    function ziel() { return feld || D.querySelector('[data-lr-picker]') || D.querySelector('[data-sch-form]') || D.getElementById('sch'); }
    D.addEventListener('click', function (ev) {
      var b = ev.target.closest && ev.target.closest('[data-lrpd-gestalten]');
      if (!b) return;
      var z = ziel(); if (!z) return;
      ev.preventDefault();
      if (feld) {
        try { feld.focus({ preventScroll: true }); } catch (e) { feld.focus(); }
        var box = feld.closest('[data-sch-perso]') || feld;
        box.scrollIntoView({ behavior: RUHIG ? 'auto' : 'smooth', block: 'center' });
      } else {
        z.scrollIntoView({ behavior: RUHIG ? 'auto' : 'smooth', block: 'start' });
      }
    });

    /* ---------- 3) Klebeleiste (Handy) ---------- */
    var leiste = D.querySelector('[data-lrpd-leiste]');
    var cta = D.querySelector('[data-sch-cta]');
    if (!leiste || !cta || !feld || !('IntersectionObserver' in window)) return;
    var vorbei = false, sichtbar = 0;
    var schmal = window.matchMedia('(max-width: 899px)');
    function zeigen() {
      /* Feld leer + Kaufbereich weg: Kaufleiste aus; unsere Leiste nur, wenn gerade kein „Jetzt gestalten“-Knopf zu sehen ist */
      var leer = schmal.matches && vorbei && !feld.value.trim();
      var an = leer && sichtbar === 0;
      leiste.classList.toggle('is-an', an);
      leiste.setAttribute('aria-hidden', an ? 'false' : 'true');
      var k = leiste.querySelector('button'); if (k) k.tabIndex = an ? 0 : -1;
      H.classList.toggle('lrpd-klebt', leer);
    }
    new IntersectionObserver(function (es) {
      var e = es[0]; vorbei = !e.isIntersecting && e.boundingClientRect.top < 0; zeigen();
    }).observe(cta);
    /* Solange ein „Jetzt gestalten“-Knopf im Abschnitt zu sehen ist, braucht es die Leiste nicht */
    var knopfIO = new IntersectionObserver(function (es) {
      es.forEach(function (e) { sichtbar += e.isIntersecting ? 1 : (e.target.__lrpdDa ? -1 : 0); e.target.__lrpdDa = e.isIntersecting; });
      if (sichtbar < 0) sichtbar = 0; zeigen();
    });
    [].forEach.call(D.querySelectorAll('.lrpd-cta [data-lrpd-gestalten]'), function (b) { knopfIO.observe(b); });
    feld.addEventListener('input', zeigen);
    if (schmal.addEventListener) schmal.addEventListener('change', zeigen);
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', los); else los();
})();
